// extracted by mini-css-extract-plugin
export default {"recos":"v5-z","productCardOverride":"w5-z","rowHasBadge":"x5-z"};